import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TodoExtended } from "models/propTypes/todoPropTypes";
import { Map, List, Record, RecordOf } from "immutable";
import { Loading } from "models/enums/loading";

interface TodoKeyProps {
  type: WintSuperkollAPIModel.TodoType;
  id: number | string;
}

const todoKeyFactory: Record.Factory<TodoKeyProps> = Record<TodoKeyProps>({
  type: WintSuperkollAPIModel.TodoType.IncomingInvoice,
  id: -1,
});

export function makeTodoKey(todo: WintSuperkollAPIModel.Todo) {
  return todoKeyFactory({ type: todo.type, id: todo.guidId ?? todo.id });
}

export type TodoKey = RecordOf<TodoKeyProps>;

export interface TodoInfo {
  total: number;
  items: List<TodoKey>;
}

export interface TodoState {
  todoLoadingState: Loading;
  todoSummaryLoadingState: Loading;
  todoCount?: number;
  items?: List<TodoKey>;
  itemMap?: Map<TodoKey, TodoExtended>;
  showTodos: boolean;
  todoSummary?: WintSuperkollAPIModel.TodoSummary;
  urgencyMap?: Map<WintSuperkollAPIModel.TodoUrgency, TodoInfo>;
  groupMap?: Map<WintSuperkollAPIModel.TodoGroup, TodoInfo>;
  lastViewedType?: { group: WintSuperkollAPIModel.TodoGroup; subTypes?: WintSuperkollAPIModel.TodoSubType[] };
  lastViewedTab?: WintSuperkollAPIModel.TodoGroupType;
  todoNavigationState?: TodoNavigationState;
}

export interface TodoNavigationState {
  currentNavigationItems?: TodoExtended[];
  indexToOpen?: number;
  pageToOpen?: number;
  numPerPage?: number;
  totalItems?: number;
  refreshRequestId?: number;
  loadNext?: (page: number) => Promise<{ items: WintSuperkollAPIModel.Todo[]; totalItems: number }>;
  todoCanIncludeInNavigation?: (todo: WintSuperkollAPIModel.Todo) => boolean;
}
